import React from "react";
import { Box } from "@mui/material";
import { useDroppable } from "@dnd-kit/core";
import colors from "../../../Constants/colors";

interface AnnexDropZoneProps {
  children: React.ReactNode;
}

export const AnnexDropZone: React.FC<AnnexDropZoneProps> = ({ children }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: "annex-drop-zone",
  });

  return (
    <Box
      ref={setNodeRef}
      sx={{
        minHeight: 200,
        border: isOver
          ? `2px dashed ${colors.accent}`
          : `2px dashed ${colors.gray200}`,
        borderRadius: 2,
        transition: "border-color 0.2s",
        p: 2,
        bgcolor: isOver ? colors.orange50 : "transparent",
      }}
    >
      {children}
    </Box>
  );
};
